import { FormHelperText, FormControl, OutlinedInput, Box, IconButton, Typography } from '@mui/material';
import React, { useState, useEffect } from "react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


export function InputPersonalizadoGrande({ value, valueLabel, placeholderValue, onChange }: { value: string, valueLabel: string, placeholderValue: string, onChange: (event: React.ChangeEvent<HTMLInputElement>) => void }) {


  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
  };

  return (
    <>
      <FormHelperText id="outlined-weight-helper-text">{valueLabel}</FormHelperText>
      <FormControl fullWidth variant="outlined">
        <OutlinedInput
          id="outlined-adornment-weight"
          aria-describedby="outlined-weight-helper-text"
          placeholder={placeholderValue}
          inputProps={{
            'aria-label': 'weight',
            onChange: handleInputChange,
            value: value,
            sx: { bordeRadius: 2 }
          }}

        />
      </FormControl>
    </>)
}

export function InputSoloNumeros({ value, valueLabel, onChange }: { value: string, valueLabel: string, onChange: (event: React.ChangeEvent<HTMLInputElement>) => void }) {

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (/^\d*$/.test(newValue)) {  // Solo permite dígitos
      onChange(event);
    }
  };

  return (
    <>
      <FormHelperText id="outlined-weight-helper-text">{valueLabel}</FormHelperText>
      <FormControl fullWidth variant="outlined">
        <OutlinedInput
          id="outlined-adornment-weight"
          aria-describedby="outlined-weight-helper-text"
          inputProps={{
            'aria-label': 'weight',
            pattern: "\\d*",  // Solo permite dígitos
            onChange: handleInputChange,
            value: value,
            sx: { borderRadius: 2 }
          }}
        />
      </FormControl>
    </>
  );
}

type InputPersonalizadoProps = {
  value: string;
  valueLabel: string;
  placeholderValue: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export function InputPersonalizado({
  value,
  valueLabel,
  placeholderValue,
  onChange,
}: InputPersonalizadoProps) {
  return (
    <>
      <FormHelperText id="outlined-weight-helper-text">
        {valueLabel}
      </FormHelperText>
      <FormControl variant="outlined">
        <OutlinedInput
          id="outlined-adornment-weight"
          aria-describedby="outlined-weight-helper-text"
          placeholder={placeholderValue}
          value={value}
          onChange={onChange}
          inputProps={{ "aria-label": "weight" }}
        />
      </FormControl>
    </>
  );
}


interface InputPersonalizadoTelefonoProps {
  ddn: string;
  telefono: string;
  valueLabel: string;
  onChangeDdn: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeTelefono: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function InputPersonalizadoTelefono({
  ddn,
  telefono,
  valueLabel,
  onChangeDdn,
  onChangeTelefono,
}: InputPersonalizadoTelefonoProps) {

  return (
    <>
      <FormHelperText id="outlined-weight-helper-text">{valueLabel}</FormHelperText>
      <Box display="flex" gap={1}>
        <FormControl variant="outlined" sx={{ width: '20%' }}>
          <OutlinedInput
            id="outlined-adornment-ddn"
            aria-describedby="outlined-weight-helper-text"
            placeholder='011'
            inputProps={{
              'aria-label': 'ddn',
              value: ddn,
              onChange: onChangeDdn,
              sx: { borderRadius: 2, textAlign: 'center' },
            }}
          />
        </FormControl>

        <FormControl variant="outlined" sx={{ width: '80%' }}>
          <OutlinedInput
            id="outlined-adornment-telefono"
            aria-describedby="outlined-weight-helper-text"
            placeholder='12345678'
            inputProps={{
              'aria-label': 'celular',
              value: telefono,
              onChange: onChangeTelefono,
              sx: { borderRadius: 2 },
            }}
          />
        </FormControl>
      </Box>
    </>
  );
}

export function InputPersonalizadoTelefonoAnimacion() {
  const [telefono, setTelefono] = useState("");
  const [ddn, setDdn] = useState("011");
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [inputColor, setInputColor] = useState("red"); // Rojo por defecto

  useEffect(() => {
    const animatePhoneNumber = () => {
      // Paso 1: Muestra la cruz roja
      setShowError(true);
      setInputColor("red"); // Color rojo mientras es incorrecto

      let fullNumber = "011 12345678"; // Número completo con el código de área
      let finalNumber = "12345678"; // El número final después de borrar el "011"
      let index = 0;

      // Escribir el número completo primero (011 12345678)
      const interval = setInterval(() => {
        setTelefono((prev) => {
          const newTelefono = fullNumber.substring(0, index + 1);
          index += 1;
          return newTelefono;
        });

        if (index >= fullNumber.length) {
          clearInterval(interval); // Para cuando termina de escribir el número completo

          setTimeout(() => {
            setTelefono(""); // Borra el número completo
            setShowError(false); // Esconde la cruz roja
            setShowSuccess(true); // Muestra el tilde verde
            setInputColor("green"); // Cambiar a verde cuando se escribe correctamente

            // Escribir el nuevo número sin "011" (12345678)
            let finalIndex = 0;
            const finalInterval = setInterval(() => {
              setTelefono((prev) => {
                const newTelefono = finalNumber.substring(0, finalIndex + 1);
                finalIndex += 1;
                return newTelefono;
              });

              if (finalIndex >= finalNumber.length) {
                clearInterval(finalInterval); // Para cuando termina de escribir el número final
                setTimeout(() => {
                  setShowSuccess(false); // Esconde el tilde verde
                  animatePhoneNumber(); // Vuelve a comenzar el ciclo
                }, 1000); // Espera antes de reiniciar el ciclo
              }
            }, 300); // Velocidad de escritura (300 ms por carácter)
          }, 1000); // Espera un poco después de borrar el número
        }
      }, 300); // Velocidad de escritura (300 ms por carácter)

      return () => clearInterval(interval); // Limpieza al desmontar
    };

    animatePhoneNumber(); // Inicia el ciclo de animación

  }, []); // Solo se ejecuta una vez al principio

  return (
    <Box>
      <FormHelperText id="outlined-weight-helper-text">Teléfono Celular</FormHelperText>
      <Box display="flex" gap={1} alignItems="center"> {/* Alineación de los elementos */}
        <FormControl variant="outlined" sx={{ width: "30%" }}>
          <OutlinedInput
            id="outlined-adornment-ddn"
            value={ddn}
            disabled
            sx={{
              borderRadius: 2,
              backgroundColor: "#dcdcdc", // Fondo gris más visible
            }}
          />
        </FormControl>

        <FormControl variant="outlined" sx={{ width: "70%" }}>
          <OutlinedInput
            id="outlined-adornment-telefono"
            value={telefono}
            disabled
            sx={{
              borderRadius: 2,
              backgroundColor: inputColor === "green" ? "#d4edda" : inputColor === "red" ? "#f8d7da" : "#f5f5f5", // Cambiar el color de fondo según el estado
            }}
          />
        </FormControl>

        <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
          {showError && (
            <ErrorOutlineIcon
              color="error"
              sx={{
                fontSize: 40,
                animation: "blink 1s infinite", // Animación de parpadeo de la cruz
              }}
            />
          )}
          {showSuccess && (
            <CheckCircleIcon color="success" sx={{ fontSize: 40 }} />
          )}
        </Box>
      </Box>

      {/* Estilo para la animación de la cruz */}
      <style>
        {`
          @keyframes blink {
            0% {
              opacity: 1;
            }
            50% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
        `}
      </style>
    </Box>
  );
}